import React, { useState, useEffect } from 'react';
// import { useAuth } from '@/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Plus, Edit2, Trash2, LogOut } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Switch } from '../components/ui/switch';
import { toast } from 'sonner';

import { collection, addDoc } from "firebase/firestore";
import { onSnapshot, query, orderBy } from "firebase/firestore";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../firebase";
import { updateDoc } from "firebase/firestore";

import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { signOut } from "firebase/auth";

const AdminPage = () => {
  const [user, setUser] = useState(null);
  // const { user, loading, login, logout } = useAuth();
  const navigate = useNavigate();
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const [products, setProducts] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    image: '',
    price: '',
    amazon_link: '',
    category: 'Home',
    featured: false,
    trending: false
  });

  // useEffect(() => {
  //   setProducts([
  //     {
  //       id: 1,
  //       name: "Sample Product",
  //       image: "https://via.placeholder.com/150",
  //       price: 499,
  //       category: "Home",
  //       featured: true,
  //       trending: true
  //     }
  //   ]);
  // }, []);
  useEffect(() => {
    const q = query(
      collection(db, "products"),
      orderBy("createdAt", "desc") // 👈 latest first
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setProducts(data);
    });

    return () => unsubscribe();
  }, []);

  const handleAddProduct = async () => {
    try {
      await addDoc(collection(db, "products"), {
        name: formData.name,
        price: Number(formData.price),
        image: formData.image,
        category: formData.category,
        amazon_link: formData.amazon_link,
        featured: formData.featured,
        trending: formData.trending,
        createdAt: new Date()
      });

      alert("Product Added ✅");
      setIsDialogOpen(false);
      resetForm();
    } catch (err) {
      console.error(err);
      alert("Error adding product ❌");
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (editingProduct) {
      await handleUpdate(editingProduct.id);
    } else {
      await handleAddProduct();
    }
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "products", id));
    alert("Deleted ✅");
  };

  const handleUpdate = async (id) => {
    const ref = doc(db, "products", id);

    await updateDoc(ref, {
      name: formData.name,
      price: Number(formData.price),
      image: formData.image,
      category: formData.category,
      amazon_link: formData.amazon_link,
      featured: formData.featured,
      trending: formData.trending
    });

    alert("Updated ✅");
  };
  const openEditDialog = (product) => {
    setEditingProduct(product);
    setFormData({
      name: product.name,
      image: product.image,
      price: product.price.toString(),
      amazon_link: product.amazon_link,
      category: product.category,
      featured: product.featured,
      trending: product.trending
    });
    setIsDialogOpen(true);
  };

  const resetForm = () => {
    setEditingProduct(null);
    setFormData({
      name: '',
      image: '',
      price: '',
      amazon_link: '',
      category: 'Home',
      featured: false,
      trending: false
    });
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      await signInWithEmailAndPassword(auth, email, password);
      alert("Login success ✅");
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  const handleLogout = async () => {
    await signOut(auth);
  };

  /*dashboard*/
  const totalProducts = products.length;
  const totalClicks = products.reduce((sum, p) => sum + (p.clicks || 0), 0);
  const trendingCount = products.filter(p => p.trending).length;
  const featuredCount = products.filter(p => p.featured).length;
  /*search & sort controls*/
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("latest");

  /*filtered & sorted products*/
  const filteredProducts = products
    .filter(p =>
      p.name.toLowerCase().includes(search.toLowerCase())
    )
    .sort((a, b) => {
      if (sortBy === "clicks") return (b.clicks || 0) - (a.clicks || 0);
      if (sortBy === "price_low") return a.price - b.price;
      if (sortBy === "price_high") return b.price - a.price;
      return new Date(b.createdAt?.seconds || 0) - new Date(a.createdAt?.seconds || 0);
    });

  /*Top Performing Products*/
  const topProducts = [...products]
    .sort((a, b) => (b.clicks || 0) - (a.clicks || 0))
    .slice(0, 3);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });

    return () => unsubscribe();
  }, []);

  if (!user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <form
          onSubmit={handleLogin}
          className="bg-white p-8 rounded-2xl shadow-lg w-80"
        >
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-green-200 rounded-full flex items-center justify-center text-2xl">
              👤
            </div>
          </div>

          <h2 className="text-center text-xl font-semibold mb-6">
            Admin Login
          </h2>

          <input
            type="email"
            placeholder="Email"
            className="w-full mb-4 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            type="password"
            placeholder="Password"
            className="w-full mb-4 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <button
            type="submit"
            className="w-full bg-green-500 text-white py-2 rounded-lg hover:bg-green-600 transition"
          >
            LOGIN
          </button>
        </form>
      </div>
    );
  }





  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FAF8F5' }} data-testid="admin-dashboard">
      {/* Header */}
      <header className="border-b" style={{ backgroundColor: 'white', borderColor: 'rgba(44, 48, 46, 0.08)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <h1 className="text-2xl font-semibold" style={{ color: '#2C302E' }} data-testid="admin-title">Admin Panel</h1>
            <div className="flex items-center gap-4">
              <Button
                variant="outline"
                onClick={() => navigate('/')}
                className="rounded-xl"
                data-testid="view-site-btn"
              >
                View Site
              </Button>
              <Button
                variant="outline"
                onClick={handleLogout}
                className="rounded-xl flex items-center gap-2"
                data-testid="logout-btn"
              >
                <LogOut size={18} />
                Logout
              </Button>
            </div>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
          <div className="bg-white p-4 rounded-xl shadow">
            <p>Total Products</p>
            <h2 className="text-xl font-bold">{totalProducts}</h2>
          </div>

          <div className="bg-white p-4 rounded-xl shadow">
            <p>Total Clicks</p>
            <h2 className="text-xl font-bold">{totalClicks}</h2>
          </div>

          <div className="bg-white p-4 rounded-xl shadow">
            <p>Trending</p>
            <h2 className="text-xl font-bold">{trendingCount}</h2>
          </div>

          <div className="bg-white p-4 rounded-xl shadow">
            <p>Featured</p>
            <h2 className="text-xl font-bold">{featuredCount}</h2>
          </div>
        </div>

        <div className="mb-8">
          <h3 className="text-xl mb-4">🔥 Top Performing</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {topProducts.map(p => (
              <div key={p.id} className="bg-white p-4 rounded-xl shadow flex gap-3 items-center">

                {/* Image */}
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-16 h-16 object-cover rounded-lg"
                />

                {/* Info */}
                <div className="flex-1">
                  <p className="text-sm font-medium line-clamp-2">{p.name}</p>
                  <p className="text-xs text-gray-500">Clicks: {p.clicks || 0}</p>
                </div>

              </div>
            ))}
          </div>
        </div>

        <div className="flex gap-4 mb-6">
          <input
            placeholder="Search product..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="border px-3 py-2 rounded-lg"
          />
          
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="border px-3 py-2 rounded-lg"
          >
            <option value="latest">Latest</option>
            <option value="clicks">Most Clicked</option>
            <option value="price_low">Price Low</option>
            <option value="price_high">Price High</option>
          </select>
        </div>
      </div>



      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-2xl font-medium" style={{ color: '#2C302E' }} data-testid="products-title">Products</h2>
          <Dialog open={isDialogOpen} onOpenChange={(open) => {
            setIsDialogOpen(open);
            if (!open) resetForm();
          }}>
            <DialogTrigger asChild>
              <Button
                className="rounded-xl flex items-center gap-2"
                style={{ backgroundColor: '#8CA692', color: 'white' }}
                data-testid="add-product-btn"
              >
                <Plus size={18} />
                Add Product
              </Button>
            </DialogTrigger>
            <DialogContent className="max-w-2xl" data-testid="product-dialog">
              <DialogHeader>
                <DialogTitle data-testid="dialog-title">{editingProduct ? 'Edit Product' : 'Add New Product'}</DialogTitle>
              </DialogHeader>
              <form onSubmit={handleSubmit} className="space-y-6 mt-4">
                <div>
                  <Label htmlFor="name">Product Name</Label>
                  <Input
                    id="name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="mt-2 rounded-xl"
                    required
                    data-testid="product-name-input"
                  />
                </div>
                <div>
                  <Label htmlFor="image">Image URL</Label>
                  <Input
                    id="image"
                    value={formData.image}
                    onChange={(e) => setFormData({ ...formData, image: e.target.value })}
                    className="mt-2 rounded-xl"
                    required
                    data-testid="product-image-input"
                  />
                </div>
                <div>
                  <Label htmlFor="price">Price (₹)</Label>
                  <Input
                    id="price"
                    type="number"
                    step="0.01"
                    value={formData.price}
                    onChange={(e) => setFormData({ ...formData, price: e.target.value })}
                    className="mt-2 rounded-xl"
                    required
                    data-testid="product-price-input"
                  />
                </div>
                <div>
                  <Label htmlFor="amazon_link">Amazon Link</Label>
                  <Input
                    id="amazon_link"
                    value={formData.amazon_link}
                    onChange={(e) => setFormData({ ...formData, amazon_link: e.target.value })}
                    className="mt-2 rounded-xl"
                    required
                    data-testid="product-amazon-link-input"
                  />
                </div>
                <div>
                  <Label htmlFor="category">Category</Label>
                  <Select
                    value={formData.category}
                    onValueChange={(value) => setFormData({ ...formData, category: value })}
                  >
                    <SelectTrigger className="mt-2 rounded-xl" data-testid="product-category-select">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent position="popper" sideOffset={5}>
                      <SelectItem value="Study">Study</SelectItem>
                      <SelectItem value="Home">Home</SelectItem>
                      <SelectItem value="Kitchen">Kitchen</SelectItem>
                      <SelectItem value="Decor">Decor</SelectItem>
                      <SelectItem value="Fashion">Fashion</SelectItem>
                      <SelectItem value="Plants">Plants</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div className="flex items-center justify-between">
                  <Label htmlFor="featured">Featured</Label>
                  <Switch
                    id="featured"
                    checked={formData.featured}
                    onCheckedChange={(checked) => setFormData({ ...formData, featured: checked })}
                    data-testid="product-featured-toggle"
                  />
                </div>
                <div className="flex items-center justify-between">
                  <Label htmlFor="trending">Trending</Label>
                  <Switch
                    id="trending"
                    checked={formData.trending}
                    onCheckedChange={(checked) => setFormData({ ...formData, trending: checked })}
                    data-testid="product-trending-toggle"
                  />
                </div>
                <div className="flex gap-3">
                  <Button
                    type="submit"
                    className="flex-1 rounded-xl"
                    style={{ backgroundColor: '#8CA692', color: 'white' }}
                    data-testid="save-product-btn"
                  >
                    {editingProduct ? 'Update Product' : 'Create Product'}
                  </Button>
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => {
                      setIsDialogOpen(false);
                      resetForm();
                    }}
                    className="flex-1 rounded-xl"
                    data-testid="cancel-btn"
                  >
                    Cancel
                  </Button>
                </div>
              </form>
            </DialogContent>
          </Dialog>
        </div>

        {/* Products Table */}
        <div className="bg-white rounded-2xl overflow-hidden" style={{ boxShadow: '0 8px 30px rgba(0,0,0,0.04)' }} data-testid="products-table">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead style={{ backgroundColor: '#FAF8F5' }}>
                <tr>
                  <th className="px-6 py-4 text-left text-sm font-medium" style={{ color: '#2C302E' }}>Image</th>
                  <th className="px-6 py-4 text-left text-sm font-medium" style={{ color: '#2C302E' }}>Name</th>
                  <th className="px-6 py-4 text-left text-sm font-medium" style={{ color: '#2C302E' }}>Price</th>
                  <th className="px-6 py-4 text-left text-sm font-medium" style={{ color: '#2C302E' }}>Category</th>
                  <th className="px-6 py-4 text-left text-sm font-medium" style={{ color: '#2C302E' }}>Clicks</th>
                  <th className="px-6 py-4 text-left text-sm font-medium" style={{ color: '#2C302E' }}>Featured</th>
                  <th className="px-6 py-4 text-left text-sm font-medium" style={{ color: '#2C302E' }}>Trending</th>
                  <th className="px-6 py-4 text-left text-sm font-medium" style={{ color: '#2C302E' }}>Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y" style={{ borderColor: 'rgba(44, 48, 46, 0.08)' }}>
                {filteredProducts.map((product) => (
                  <tr key={product.id} data-testid={`product-row-${product.id}`}>
                    <td className="px-6 py-4">
                      <img src={product.image} alt={product.name} className="w-16 h-16 object-cover rounded-lg" />
                    </td>
                    <td className="px-6 py-4 text-sm" style={{ color: '#2C302E' }}>{product.name}</td>
                    <td className="px-6 py-4 text-sm font-medium" style={{ color: '#8CA692' }}>₹{product.price}</td>
                    <td className="px-6 py-4 text-sm" style={{ color: '#5B635E' }}>{product.category}</td>
                    <td>{product.clicks || 0}</td>
                    <td className="px-6 py-4">
                      <span className={`px-3 py-1 rounded-full text-xs ${product.featured ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>
                        {product.featured ? 'Yes' : 'No'}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span className={`px-3 py-1 rounded-full text-xs ${product.trending ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600'}`}>
                        {product.trending ? 'Yes' : 'No'}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex gap-2">
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={() => {
                            const url = `${window.location.origin}/?product=${product.id}`;
                            navigator.clipboard.writeText(url);
                            alert("Product link copied ✅");
                          }}
                        >
                          🔗 Copy Link
                        </Button>
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={() => openEditDialog(product)}
                          data-testid={`edit-btn-${product.id}`}
                        >
                          <Edit2 size={16} />
                        </Button>
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={() => handleDelete(product.id)}
                          style={{ color: '#e74c3c' }}
                          data-testid={`delete-btn-${product.id}`}
                        >
                          <Trash2 size={16} />
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AdminPage;